import { Link } from 'react-router-dom';
import '../styles/Page.css';

export default function Projects() {
  return (
    <div className="page-wrapper">
      <Link to="/" className="page-back">\u2190 Back to Home</Link>
      <h1 className="page-title">🛠️ Projects</h1>
      <p className="page-subtitle">Things I've built — personal projects, team work, and experiments.</p>
      <div className="placeholder-box">
        <div className="icon">🛠️</div>
        <p>Content for <strong>Projects</strong> goes here.</p>
        <p style={{ marginTop: 8, fontSize: '0.8rem' }}>Fill this section with your own information.</p>
      </div>
    </div>
  );
}
